import { toggleAlertModule } from "./alert.actions"
import { updateItemSelected } from "./menuActions"
import { updateSession } from "./session.actions"

export const APP_CHANGE_THEME = 'APP_CHANGE_THEME'

export const changeTheme = (theme = 'ligth') => ({
	type: APP_CHANGE_THEME,
	payload: { theme }
})

export const clearApp = () => {
	return (dispatch) => {
		dispatch(toggleAlertModule())
		dispatch(updateSession())
    dispatch(updateItemSelected({ item: '', subItem: '' }))
	}
}